import styled from 'styled-components'
import { HEADER_HEIGHT, COLORS } from '~/components/UI/Constants'
import Box from '~/components/UI/Box'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Link from 'next/link'
import MoreMenu from './MoreMenu'
import Icon from '../UI/Icon'
// import LangMenu from './Lang'
import UserMenu from './UserMenu'
import { useRouter } from 'next/router'
import { useState, useEffect, useMemo } from 'react'
import { ROUTES, HOTLINE } from '~/constant'
import useUser from '~/modules/user/useUser'
import { minWidth } from '~/components/UI/breakpoints'
import BurgerMenu from './BurgerMenu'
import initBurger from './handleBurgerMenu'
import isLightMode from './isLightMode'
import Button from '~/components/UI/Button'
// import useLang from '~/modules/lang/useLang'
import Avatar from '~/components/UI/Avatar'
import HeaderItemLink from './HeaderItemLink'
import getcdn from '~/modules/get_cdn_link'

const MyContainer = styled.div`
  height: ${HEADER_HEIGHT}px;
  background-color: transparent;
  position: relative;
  width: 100vw;
  z-index: 10000;
  display: flex;
  align-items: center;
  padding: 0 20px;
  transition: 250ms;
  &.navbar_shown {
    background-color: #fff;
    box-shadow: rgba(0, 85, 255, 0.1) 0px 2px 10px 0px;
  }
  p {
    font-size: 14px;
  }
  &.header-light-mode {
    p,
    .header-icon,
    .header-burger-icon span {
      color: #fff;
    }
    .phone-call-icon span:before {
      color: #fff;
    }
    p:before,
    .header-sep {
      background-color: #fff;
    }

    .header-logo {
      background-image: url(${getcdn('img/white-logo.png')});
    }
  }
`

const Logo = styled.div`
  width: 126px;
  height: 60px;
  background-image: url(${getcdn('img/logo_header.png?ver=2')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

const MenuContainer = styled(Box)`
  flex: 1;
  justify-content: flex-end;

  .header-desktop {
    display: none;
    ${minWidth(1100)} {
      display: inline-block;
    }
  }
`

// const LangImg = styled.img`
//   width: 16px;
//   margin-right: 10px;
// `

// const Separator = styled.span`
//   width: 1px;
//   background-color: #000;
//   height: 30px;
//   display: inline-block;
//   opacity: 0.5;
// `

const Header = () => {
  const [t] = useTranslation()
  const { user } = useUser()
  const [lightmode, setLightMode] = useState(false)
  // const { selectedLang } = useLang()
  const router = useRouter()
  useEffect(() => {
    setLightMode(isLightMode())
  }, [router])

  useEffect(() => {
    initBurger()
  }, [])

  const rightMenu = useMemo(() => {
    if (user) {
      return (
        <div className="header-desktop" style={{ position: 'relative' }}>
          <HeaderItemLink className="user-menu" as="a">
            <Avatar
              style={{
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
              size={24}
              src={user?.avatar}
            />
            <Text style={{ marginLeft: 30 }}>{`${user?.kyc?.last_name || ''} ${user?.kyc?.first_name || ''}`}</Text>
            <Icon className="header-icon" style={{ marginLeft: 5 }} name="drop-down" />
          </HeaderItemLink>
          <UserMenu />
        </div>
      )
    }
    return (
      <>
        <Link href={ROUTES.APP_DOWNLOAD}>
          <Button  className="header-desktop" primary style={{ height: 40 }} border="0">
            <Text color="#fff">{t`Tải App`}</Text>
          </Button>
        </Link>
      </>
    )
  }, [user, t])

  // const langMenu = useMemo(() => {
  //   return (
  //     <div style={{ position: 'relative' }}>
  //       <HeaderItemLink className="header-lang">
  //         <LangImg src={selectedLang.img} />
  //         <Text style={{ textTransform: 'capitalize' }}>{selectedLang.text}</Text>
  //         <Icon className="header-icon" style={{ marginLeft: 5 }} name="drop-down" />
  //       </HeaderItemLink>
  //       <LangMenu />
  //     </div>
  //   )
  // }, [selectedLang])

  return (
    <>
      <MyContainer id="header-navbar" className={lightmode ? 'header-light-mode' : ''}>
        <Link href={ROUTES.HOME}>
          <a>
            <Logo className="header-logo" />
          </a>
        </Link>
        <MenuContainer flex align="center">
          <HeaderItemLink className="phone-call-icon" href={`tel:${HOTLINE}`} as="a">
            <Icon name="phone-call" />
            <Text padding="0 0 0 5px" bold color={COLORS.PRIMARY}>
              {HOTLINE}
            </Text>
          </HeaderItemLink>          
          <HeaderItemLink href={ROUTES.MF_INFO} className="header-desktop" as="a">
            <Text>{t`Chứng chỉ quỹ`}</Text>
          </HeaderItemLink>
          <HeaderItemLink href={ROUTES.STOCK_INFO} className="header-desktop" as="a">
            <Text>{t`Chứng khoán`}</Text>
          </HeaderItemLink>
          <HeaderItemLink href={ROUTES.SAVING_INFO} className="header-desktop" as="a">
            <Text>{t`Tích luỹ`}</Text>
          </HeaderItemLink>
          <HeaderItemLink href={ROUTES.CD_INFO} className="header-desktop" as="a">
            <Text>{t`Chứng chỉ tiền gửi`}</Text>
          </HeaderItemLink>
          <div className="header-desktop" style={{ position: 'relative' }}>
            <MoreMenu
              id="bds-menu"
              title={t`Bất động sản`}
              list={[
                { text: t`Giới thiệu`, link: ROUTES.REAL_ESTATE_INTRODUCTION },
                { text: t`Danh sách dự án`, link: ROUTES.PROPERTY_LIST },
              ]}
            />
          </div>
          <HeaderItemLink target="_blank" href={ROUTES.BLOG} className="header-desktop" as="a">
            <Text>{t`Blog`}</Text>
          </HeaderItemLink>
          <HeaderItemLink target="_blank" href={ROUTES.SUPPORT} className="header-desktop" as="a">
            <Text>{t`Hỗ trợ`}</Text>
          </HeaderItemLink>
          <Link href={ROUTES.PRESS}>
            <HeaderItemLink href={ROUTES.PRESS} className="header-desktop" as="a">
              <Text>{t`Báo Chí`}</Text>
            </HeaderItemLink>
          </Link>
          <Link href={ROUTES.ABOUT_US}>
            <HeaderItemLink href={ROUTES.ABOUT_US} className="header-desktop" as="a">
              <Text>{t`Về Chúng Tôi`}</Text>
            </HeaderItemLink>
          </Link>
          {/*  */}
          {/* {langMenu} */}

          {rightMenu}
          {/* ============== burger icon ==============  */}
          <HeaderItemLink className="header-burger-icon" as="a">
            <Icon bold size={18} name="buger-menu" />
          </HeaderItemLink>

          {/* <Separator className="header-desktop header-sep" /> */}

        </MenuContainer>
      </MyContainer>
      <BurgerMenu />
    </>
  )
}

export default Header
